import PropTypes from 'prop-types';
import React from 'react';
import SiteNavDropdownColumn from './SiteNavDropdownColumn';

import styles from './SiteNav-style.scss';

const SiteNavDropdownContent = ({ items: moduleItems, trackingLabelPrefix }) => {
    const itemsCols = moduleItems.reduce(
        (acc, moduleItem) => {
            const { type } = moduleItem;

            switch (type) {
                case 'primary':
                    acc.primary.push(moduleItem);
                    break;
                default:
                    acc.secondary.push(moduleItem);
            }
            return acc;
        },
        { primary: [], secondary: [] }
    );

    const { primary, secondary } = itemsCols;

    return (
        <div className={styles.dropdownContent}>
            {primary.length ? (
                <SiteNavDropdownColumn items={primary} trackingLabelPrefix={trackingLabelPrefix} />
            ) : null}
            {secondary.length ? (
                <SiteNavDropdownColumn
                    items={secondary}
                    trackingLabelPrefix={trackingLabelPrefix}
                />
            ) : null}
        </div>
    );
};

SiteNavDropdownContent.propTypes = {
    items: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
};

export default SiteNavDropdownContent;
